import * as React from "react";
import { Separator } from "@/components/ui/separator";
const partners = [{
  id: 1,
  name: "Miller Electric",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591728/img/apex_construction_logo.png"
}, {
  id: 2,
  name: "Lincoln Electric",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591728/img/lumina_materials_logo.png"
}, {
  id: 3,
  name: "Hypertherm",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591728/img/structura_engineering_logo.png"
}, {
  id: 4,
  name: "Hobart Welding",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591728/img/ecobuild_standards_logo.png"
}];
export default function IndustrySeals() {
  return <section data-section-id="125267" id="authorized-brand-expertise" className="dark bg-card text-foreground pt-12 flex flex-col">
      <div className="container mx-auto px-4 md:px-6 pb-12">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 lg:gap-24">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex items-center justify-center">
              <img src={partner.logo} alt={partner.name} className="h-8 md:h-10 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 hover:drop-shadow-[0_0_12px_rgba(249,161,46,0.5)] transition-all duration-300" loading="lazy" />
            </div>)}
        </div>
      </div>
      <Separator className="w-full bg-border" />
    </section>;
}